// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { previousThursday as fn } from "../previousThursday.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const previousThursdayWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default previousThursdayWithOptions;
